import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import ChartComponent from "../FixedReportChart";

class MeetingFeedback extends React.Component {
  constructor(props) {
    super(props);

    // Get feedback options from local storage
    const feedbackOptions = reactLocalStorage.getObject(Constants.Model).meeting.fields.feedback.options;
    this.state = {
      feedbackData: [],
      feedbackOptions,
      inApiCall: true,
    };
  }

  componentDidMount() {
    // Fetch meeting feedback data
    DailySalesReportAPI.getMeetingfeedback(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    // Filter out feedback with value 0
    const filteredData = data.filter(feedback => feedback.feedback !== 0);
    this.setState({ feedbackData: filteredData, inApiCall: false });
  };

  handleFail = () => {
    this.setState({ inApiCall: false });
  };

  render() {
    const { feedbackData, feedbackOptions, inApiCall } = this.state;

    // Create a dictionary to map feedback values to sums, defaulting to 0
    const feedbackSums = feedbackOptions.reduce((acc, option) => {
      acc[option.value] = 0;
      return acc;
    }, {});

    // Populate the feedback sums with the actual data
    feedbackData.forEach(feedback => {
      feedbackSums[feedback.feedback] += feedback.sum;
    });

    // Calculate total sum of all feedbacks from the original API response
    const totalSum = feedbackData.reduce((sum, feedback) => sum + feedback.sum, 0);

    return (
      <ApiUiController inApiCall={inApiCall}>
      <div>
        <h2>Site Visit Feedback Report</h2>
        <hr />

        <div className="row mt-3">
        <Table striped bordered hover className="col-md-5"> 
          <thead>
            <tr>  
              <th>Feedback</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {feedbackOptions.map(({ label, value }) => (
              <tr key={value}>
                <td>{label}</td>
                <td>{feedbackSums[value]}</td>
              </tr>
            ))}
            <tr>
              <td><strong>Total</strong></td>
              <td><strong>{totalSum}</strong></td>
            </tr>
          </tbody>
        </Table>
        <div className="col-md-5">
          {/* Add Chart Component */}
          <ChartComponent progressSums={feedbackSums} progressOptions={feedbackOptions} type="bar" />
        </div>
      </div>
      </div>
    </ApiUiController>
    );
  }
}

export default withRouter(MeetingFeedback);
